<template>
    <div class="scroll-image-container" ref="imgsccc">
        <div
            class="scroll-image-wrapper"
            :style="{ transform: `translateX(${scrollX}px)` }"
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @touchend="handleTouchEnd"
        >
            <div
                v-for="(image, index) in cases"
                :key="index"
                style="margin-right: 20px"
                @load="imageLoaded"
                  ref="imgdiv"
            >
                <img :src="image.img" />
                <div class="imgBom">
                    <h2 class="title">{{ image.title }}</h2>
                    <p class="con">{{ image.content }}</p>
                </div>
            </div>
        </div>
        <div class="custom-scrollbar">
            <div
                class="scrollbar-thumb"
                :style="{
                    width: scrollbarWidth + 'px',
                    left: scrollbarLeft + 'px',
                }"
            ></div>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="88%"
            :before-close="handleClose"
        >
            <button class="nav-button prev-button" @click="par()">&lt;</button>
            <button class="nav-button next-button" @click="next()">&gt;</button>
            <div style="height: 50%; width: 95%" class="imgBox">
                <img :src="ImgUrl" alt="" style="height: 100%; width: 100%" />
            </div>
            <div style="height: 50%; width: 95%">
                <h3 style="margin: 0 0 5px 0; text-align: center">案例简介</h3>
                <div v-html="processedString" style="line-height: 1.4"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            images: [
                require("@/assets/tecImg/图片1.png"),
                require("@/assets/tecImg/图片2.png"),
                require("@/assets/tecImg/图片3.png"),
                require("@/assets/tecImg/图片4.png"),
            ],
            cases: [
                {
                    img: require("@/assets/tecImg/图片9.png"),
                    title: "飞行作战模拟训练系统",
                    content: "客户单位：中航某单位",
                },
                {
                    img: require("@/assets/tecImg/图片10.png"),
                    title: "XR模拟训练系统",
                    content: "客户单位：中航某单位",
                },
                {
                    img: require("@/assets/tecImg/图片12.png"),
                    title: "智能诊断系统",
                    content: "客户单位：东方电气集团东方电机有限公司",
                },
                {
                    img: require("@/assets/tecImg/图片13.png"),
                    title: "智慧工厂系统",
                    content: "客户单位：东电&某涡轮研究院",
                },
            ],
            scrollX: 0,
            touchStartX: 0,
            initialScrollX: 0,
            animationFrameId: null,
            scrollbarWidth: 0,
            scrollbarLeft: 0,
            loadedImagesCount: 0,
            clickThreshold: 10,
            isClick: false,
            dialogVisible: false,
            IndexNum: 0,
            clickNum: 0,
            ImgUrl: require("../assets/ytwo0/图片0.png"),
            tableText: [
                {
                    name: "某中航单位",
                    value: "1、真实大范围地形、卫星影像与地形贴图无缝混合现实；2、模拟战斗机和武装直升机单机和联机作战；3、模拟飞行作战头盔显示画面；4、支持在VR/XR环境中使用。",
                },
                {
                    name: "某中航单位",
                    value: "1、真实大范围地形、卫星影像与地形贴图无缝混合现实；2、模拟战斗机和武装直升机单机和联机作战；3、模拟飞行作战头盔显示画面；4、支持在VR/XR环境中使用。",
                },
                {
                    name: "东电",
                    value: "1、设备三维建模，实时数据驱动；2、健康指数显示；3、运行工况显示；4、报警显示；5、状态总览；6、系统诊断信息显示。",
                },
                {
                    name: "某涡轮研究院",
                    value: "1、真实车间、设备三维建模、场景还原；2、真实业务流程模拟；3、实时数据采集与状态显示；4、支持多种成像设备，如LED大屏。",
                },
                {
                    name: "东电&东锅&东树",
                    value: "1、真实车间、设备三维建模、场景还原；2、多摄像头数据集成；3、多类型图表数据显示；4、支持多种成像设备，如LED大屏。",
                },
            ],
        };
    },
    watch: {
        IndexNum() {
            this.ImgUrl = require(`../assets/ytwo${this.IndexNum}/图片${this.clickNum}.png`);
        },
        clickNum() {},
        dialogVisible() {
            if (!this.dialogVisible) {
                this.clickNum = 0;
                this.IndexNum = 0;
            } else {
                if (this.IndexNum == 0) {
                    this.ImgUrl = require(`../assets/ytwo0/图片0.png`);
                }
            }
        },
    },
    computed: {
        processedString() {
            if (this.clickNum < 6) {
                const items = this.tableText[this.IndexNum].value.split("；");
                // 去除最后一个可能为空的元素
                if (items[items.length - 1] === "") {
                    items.pop();
                }
                // 为每个元素添加换行标签
                return items.map((item) => `${item}<br>`).join("");
            } else {
                const items = this.tableText[4].value.split("；");
                // 去除最后一个可能为空的元素
                if (items[items.length - 1] === "") {
                    items.pop();
                }
                // 为每个元素添加换行标签
                return items.map((item) => `${item}<br>`).join("");
            }
        },
    },
    methods: {
        par() {
            if (this.clickNum > 0) {
                this.clickNum--;
            }

            this.ImgUrl = require(`../assets/ytwo${this.IndexNum}/图片${this.clickNum}.png`);
        },
        next() {
            switch (this.IndexNum) {
                case 0:
                    if (this.clickNum < 3) {
                        this.clickNum++;
                    }
                    break;
                case 1:
                    if (this.clickNum < 3) {
                        this.clickNum++;
                    }
                    break;
                case 2:
                    if (this.clickNum < 0) {
                        this.clickNum++;
                    }
                    break;
                case 3:
                    if (this.clickNum < 13) {
                        this.clickNum++;
                    }
                    break;

                default:
                    break;
            }

            this.ImgUrl = require(`../assets/ytwo${this.IndexNum}/图片${this.clickNum}.png`);
        },
        handleClose(done) {
            done();
        },
        open(index) {
            if (this.isClick) {
                const clickedImage = this.cases[index];
                // console.log(index);
                this.IndexNum = index;
                this.dialogVisible = true;
            }
        },
        handleTouchStart(event) {
            event.preventDefault();
            event.stopPropagation();
            this.touchStartX = event.touches[0].clientX;
            this.initialScrollX = this.scrollX;
            const wrapper = this.$el.querySelector(".scroll-image-wrapper");
            wrapper.style.willChange = "transform";
            this.isClick = true;
        },
        handleTouchMove(event) {
            event.preventDefault();
            event.stopPropagation();
            const currentX = event.touches[0].clientX;
            const deltaX = Math.abs(currentX - this.touchStartX);
            if (deltaX > this.clickThreshold) {
                this.isClick = false;
            }
            const newScrollX =
                this.initialScrollX + (currentX - this.touchStartX);

            let b = window.innerWidth * 0.1;
            let a = this.$refs.imgdiv;
            let sum = 0;
            for (let i = 0; i < a.length; i++) {
                sum += a[i].offsetWidth - 60;
            }
            const maxScroll = -(sum - b);
            // const maxScroll = -970;
            const finalScrollX = Math.max(Math.min(newScrollX, 0), maxScroll);

            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
            }
            this.animationFrameId = requestAnimationFrame(() => {
                this.scrollX = finalScrollX;
                this.updateScrollbar();
            });
        },
        handleTouchEnd(event) {
            const wrapper = this.$el.querySelector(".scroll-image-wrapper");
            wrapper.style.willChange = "auto";
            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
            }
            this.updateScrollbar();

            if (this.isClick) {
                const target = event.changedTouches[0].target;
                const imageDiv = target.closest(".scroll-image-wrapper > div");
                if (imageDiv) {
                    const index = Array.from(
                        imageDiv.parentNode.children
                    ).indexOf(imageDiv);
                    this.open(index);
                }
            }
            this.isClick = false;
        },
        updateScrollbar() {
            const scrollContainer = this.$refs.imgsccc;
            if (scrollContainer) {
                const trackWidth = scrollContainer.offsetWidth;
                let b = window.innerWidth * 0.1;
                let a = this.$refs.imgdiv;
                let sum = 0;
                for (let i = 0; i < a.length; i++) {
                    sum += a[i].offsetWidth - 60;
                }
                const imageScrollRange = sum - b;
                // const imageScrollRange = 970;
                const imageScrollPosition = -this.scrollX;

                const { scrollbarWidth, scrollbarPosition } =
                    this.calculateScrollbarPosition(
                        imageScrollPosition,
                        imageScrollRange,
                        trackWidth
                    );

                this.scrollbarWidth = scrollbarWidth;
                this.scrollbarLeft = scrollbarPosition;
            }
        },
        calculateScrollbarPosition(
            imageScrollPosition,
            imageScrollRange,
            trackWidth
        ) {
            const scrollbarWidth = trackWidth / 4;
            const scrollbarMaxMove = trackWidth - scrollbarWidth;
            const scrollbarPosition =
                (imageScrollPosition / imageScrollRange) * scrollbarMaxMove;

            return {
                scrollbarWidth,
                scrollbarPosition,
            };
        },
        imageLoaded() {
            this.loadedImagesCount++;
            if (this.loadedImagesCount === this.images.length) {
                this.$nextTick(() => {
                    this.updateScrollbar();
                });
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.updateScrollbar();
        });
    },
    beforeDestroy() {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }
    },
};
</script>

<style scoped>
.scroll-image-container {
    width: 100%;
    height: 34%;
    overflow: hidden;
    position: relative;
}

.scroll-image-wrapper {
    display: flex;
    transition: transform 0.1s ease-out;
    will-change: transform;
    width: auto;
    height: 90%;
}

.scroll-image-wrapper img {
    min-width: 300px;
    height: 200px;
    /* width: 320px; */
    max-width: 320px;
    /* margin-right: 20px; */
}

.custom-scrollbar {
    position: relative;
    height: 4px;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 2px;
    /* bottom: 0; */
}

.scrollbar-thumb {
    position: absolute;
    height: 100%;
    background-color: rgba(11, 124, 181);
    border-radius: 2px;
    transition: left 0.1s ease-out;
}
.imgBom {
    height: 35%;
    width: 100%;
    background-color: #fff;
}
.title {
    margin-top: 0;
    font-size: 20px;
}
.con {
    font-size: 18px;
}
::v-deep .el-dialog__body {
    height: 60vh;
}
.nav-button {
    position: absolute;
    top: 27%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    height: 40px;
    width: 40px;
    border: none;
    border-radius: 20px;
    font-size: 20px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    transition: opacity 0.3s ease;
    z-index: 10;
}

/* 上一页按钮位置样式 */
.prev-button {
    left: 10px;
}

/* 下一页按钮位置样式 */
.next-button {
    right: 10px;
}
</style>